function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.80195 34.3561H34.3476V1.81045H1.80195V34.3561ZM36.1496 36.1581H0V0H36.1496V36.1581Z",
  fill: "#D0101B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.7765 14.6451H30.0977V6.31528H21.7765V14.6451ZM32.1037 16.651H19.7705V4.30933H32.1037V16.651Z",
  fill: "#D0101B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5975 15.4015V14.6451H16.3791V4.30933H14.3816V6.76576H14.3731V14.6451H12.1632H6.05185V6.31528V4.30933H4.0459V16.651H12.1632H16.3791H16.5916V18.368H18.5975V15.4015Z",
  fill: "#D0101B"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M4.0459 31.8571H6.05185V30.1402V21.8104H14.3731V29.5112H14.3816V31.8571H16.3791V19.8044H4.0459V31.8571Z",
  fill: "#D0101B"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M32.1037 19.8044H19.7705V31.8571H21.7765V29.5112V21.8104H30.0977V29.5112H30.1062V31.8571H32.1037V19.8044Z",
  fill: "#D0101B"
});

var SvgLogoBigSvg = function SvgLogoBigSvg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoBigSvg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_big_svg.13951f4e.svg";
export { ForwardRef as ReactComponent };